import type { FC } from 'react';
import { memo } from 'react';
import { Box } from '@mui/material';
import TrendsKeywordsFilter from './TrendsKeywordsFilter';
import TrendsNetworkFilter from './TrendsNetworkFilter';
import TrendsPostTypeFilter from './TrendsPostTypeFilter';
import TrendsSortByFilter from './TrendsSortByFilter';
import TrendsTimeRangeFilter from './TrendsTimeRangeFilter';
import type { PostType, SortBy, TimeRange } from '../types';

const ROW_WRAPPER_SX = {
  background: '#fff',
  boxShadow:
    '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
  p: '12px',
  borderRadius: '8px',
};

export interface TrendsFilterBarProps {
  timeRange: TimeRange;
  keywordIds: number[];
  postType: PostType;
  sortBy: SortBy;
  onTimeRangeChange: (value: TimeRange) => void;
  onKeywordsChange: (value: number[]) => void;
  onPostTypeChange: (value: PostType) => void;
  onSortByChange: (value: SortBy) => void;
}

const TrendsFilterBar: FC<TrendsFilterBarProps> = ({
  timeRange,
  keywordIds,
  postType,
  sortBy,
  onTimeRangeChange,
  onKeywordsChange,
  onPostTypeChange,
  onSortByChange,
}) => (
  <Box
    sx={{
      position: 'sticky',
      top: 0,
      left: 0,
      margin: 'auto',
      zIndex: 100,
      backgroundColor: 'background.default',
      px: 3,
      py: 1.5,
    }}
  >
    <Box
      sx={{
        ...ROW_WRAPPER_SX,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
        rowGap: 2,
      }}
    >
      <TrendsNetworkFilter />
      <TrendsTimeRangeFilter value={timeRange} onChange={onTimeRangeChange} />
      <TrendsKeywordsFilter keywordIds={keywordIds} onChange={onKeywordsChange} />
      <TrendsPostTypeFilter value={postType} onChange={onPostTypeChange} />
      <TrendsSortByFilter value={sortBy} onChange={onSortByChange} />
    </Box>
  </Box>
);

export default memo(TrendsFilterBar);
